import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  submit(event) {
    // Disable the button immediately to prevent duplicate submissions
    this.buttonTarget.disabled = true
    this.buttonTarget.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Replaying...'
  }
}
